import Client from "./Clients/AxiosClient";
const resource = "/api/v1/user";
const tryoutRankResource = "/api/v1/user/tryout-ranking";

export default {
  get() {
    return Client.get(`${resource}/dashboard`);
  },
  getBest3Ranks(jenis, kategori, search = "") {
    return Client.get(
      `${tryoutRankResource}/tryouts?search=${search}&filters=jenis:${jenis},kategori_tryout:${kategori}&sort_field=updated_at&sort_direction=desc&page=1&per_page=20`
    );
  },
  getAllRanksById(id, name = "") {
    return Client.get(`${tryoutRankResource}/tryouts/${id}?search=${name}`);
  },
};
